export default {
	processList: [],
	objProcessEdit: [],
  formValid: true,
  commercialKams: [],
  commercialOriginators: [],
  generatedLink: '',
  erfNumbers: []
}
